import { create } from "zustand";
import { getSalesforceContactId } from "../../../shared/utils/userSessionUtils";
import useAppStateStore from "../../../shared/store/AppStateStore";

function getInitialState() {
  return {
    spAddress: {},
    spCancellation: {},
    spLicense: {},
    spOther: {},
    spRegistration: {},
    spUse: {},
    spVehicle: {},
    Payload: {
      Origin: "Web",
      recordTypeId: "012Vh000000aLh3IAE",
      ContactId: getSalesforceContactId(),
      Date_to_Action__c: new Date().toISOString(),
      Reason_for_case__c: "Make a change to my policy",
      Type: "Customer Care",
      Comments: "",
      Address_Changes_Details__c: "",
      Cancellation_Details__c: "",
      Licensing_Authority_Details__c: "",
      Other_Changes_Details__c: "",
      Registration_Changes_Details__c: "",
      Use_Changes_Details__c: "",
      Vehicle_Changes_Details__c: "",
      Address_Changes__c: false,
      Licensing_Authority_Changes__c: false,
      Cancellation_Request__c: false,
      Registration_Changes__c: false,
      Use_Changes__c: false,
      Vehicle_Changes__c: false,
      Other_Changes__c: false,
      Address_Changes_Effective_From__c: "",
      Cancellation_Effective_From__c: "",
      Licensing_Auth_Changes_Effective_From__c: "",
      Other_Changes_Effective_From__c: "",
      Registration_Changes_Effective_From__c: "",
      Use_Changes_Effective_From__c: "",
      Vehicle_Changes_Effective_From__c: "",
    },
  };
}

const useSupportStore = create((set, get) => ({
  ...getInitialState(),
  updateField: (key, value) =>
    set((state) => {
      if (key in state.Payload) {
        return { Payload: { ...state.Payload, [key]: value } };
      }
      return {};
    }),
  updateStepFields: (step, fields) =>
    set((state) => {
      if (step in state) {
        return { [step]: { ...state[step], ...fields } };
      }
      return {};
    }),
  clear: () => set(() => ({ ...getInitialState() })),
}));

export default useSupportStore;
